/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  DeliveryCadenceDTO,
  SetDeliveryCadenceRequest
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Read the late-file check for each file type that can have one, with the last file that arrived.
 * @summary Get Delivery Cadences.
 */
export const getDeliveryCadences = (
    organizationID: string,
 options?: SecondParameter<typeof apiRequest<DeliveryCadenceDTO[]>>,) => {
      return apiRequest<DeliveryCadenceDTO[]>(
      {url: `/organizations/${organizationID}/delivery-cadences`, method: 'GET'
    },
      options);
    }
  /**
 * Turn on, or change, the late-file check for one file type. Only POSTransactions is supported.
 * @summary Set Delivery Cadence.
 */
export const setDeliveryCadence = (
    organizationID: string,
    arrivalType: string,
    setDeliveryCadenceRequest: SetDeliveryCadenceRequest,
 options?: SecondParameter<typeof apiRequest<DeliveryCadenceDTO>>,) => {
      return apiRequest<DeliveryCadenceDTO>(
      {url: `/organizations/${organizationID}/delivery-cadences/${arrivalType}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setDeliveryCadenceRequest
    },
      options);
    }
  /**
 * Turn off the late-file check for one file type. An open late-file warning closes.
 * @summary Remove Delivery Cadence.
 */
export const removeDeliveryCadence = (
    organizationID: string,
    arrivalType: string,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/organizations/${organizationID}/delivery-cadences/${arrivalType}`, method: 'DELETE'
    },
      options);
    }
  export type GetDeliveryCadencesResult = NonNullable<Awaited<ReturnType<typeof getDeliveryCadences>>>
export type SetDeliveryCadenceResult = NonNullable<Awaited<ReturnType<typeof setDeliveryCadence>>>
export type RemoveDeliveryCadenceResult = NonNullable<Awaited<ReturnType<typeof removeDeliveryCadence>>>
